import SecondaryCard from "./SecondaryCard";

export default SecondaryCard;
